module.exports = __webpack_public_path__ + "img/icon_language.7fb58ca2.svg";